export const compareCaptchaLogin = () => {
	$('input#inputEmail').blur(function () {
		if ($('#gcaptcha').length <= 0) {
			if (Dillards.getCookie('emlcap')) {
				var emlCap = Dillards.getCookie('emlcap');
				var inputEml = $('input#inputEmail')[0].value;
				if (!(emlCap.toLowerCase() === inputEml.toLowerCase())) {
					$('<div class="form-group captchaContainer isGcaptcha  userLogon" style="width:100%;"><div id="gcaptcha"></div></div>').insertAfter($('#captchaPlaceholder'));
					Dillards.getCaptchaSecurityCode();
				};
			};
		} else if ($('#gcaptcha').length > 0) {
			if (Dillards.getCookie('emlcap')) {
				var emlCap = Dillards.getCookie('emlcap');
				var capver = Dillards.getCookie('capver');
				var inputEml = $('input#inputEmail')[0].value;
				if (emlCap.toLowerCase() === inputEml.toLowerCase()) {
					$.ajax({
						url: "/webapp/wcs/stores/servlet/DdsLogon",
						cache: false,
						type: "POST",
						data: {
							fromCompareCaptchaLogin: 'Y',
							cookieVal: capver,
							inputEml: inputEml
						},
						dataType: "json",
						success: function (returnJSON) {
							if (returnJSON.JSON.response) {
								$('.captchaContainer').hide();
							} else {
								$('.captchaContainer').show();
							}
						}
					});
				} else {
					$('.captchaContainer').show();
				}
			};
		};
	});

	$('#logonButton').on('click', function (e) {
		e.stopPropagation();
		if ($('#gcaptcha').length <= 0) {
			if (Dillards.getCookie('emlcap')) {
				var emlCap = Dillards.getCookie('emlcap');
				var inputEml = $('input#inputEmail')[0].value;
				if (!(emlCap.toLowerCase() === inputEml.toLowerCase())) {
					$('<div class="form-group captchaContainer isGcaptcha  userLogon" style="width:100%;"><div id="gcaptcha"></div></div>').insertAfter($('#captchaPlaceholder'));
					Dillards.getCaptchaSecurityCode();
				};
			};
		};
	});
};